const svgs = {
  home: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/1999/xlink"
      viewBox="0 0 460.298 460.297"
      style="enable-background:new 0 0 460.298 460.297;"
    >
      <path d="M230.149,120.939L65.986,256.274c0,0.191-0.048,0.472-0.144,0.855c-0.094,0.38-0.144,0.656-0.144,0.852v137.041    c0,4.948,1.809,9.236,5.426,12.847c3.616,3.613,7.898,5.431,12.847,5.431h109.63V303.664h73.097v109.64h109.629    c4.948,0,9.236-1.814,12.847-5.435c3.617-3.607,5.432-7.898,5.432-12.847V257.981c0-0.76-0.104-1.334-0.288-1.707L230.149,120.939    z" />{" "}
      <path d="M457.122,225.438L394.6,173.476V56.989c0-2.663-0.856-4.853-2.574-6.567c-1.704-1.712-3.894-2.568-6.563-2.568h-54.816    c-2.666,0-4.855,0.856-6.57,2.568c-1.711,1.714-2.566,3.905-2.566,6.567v55.673l-69.662-58.245    c-6.084-4.949-13.318-7.423-21.694-7.423c-8.375,0-15.608,2.474-21.698,7.423L3.172,225.438c-1.903,1.52-2.946,3.566-3.14,6.136    c-0.193,2.568,0.472,4.811,1.997,6.713l17.701,21.128c1.525,1.712,3.521,2.759,5.996,3.142c2.285,0.192,4.57-0.476,6.855-1.998    L230.149,95.817l197.57,164.741c1.526,1.328,3.521,1.991,5.996,1.991h0.858c2.471-0.376,4.463-1.43,5.996-3.138l17.703-21.125    c1.522-1.906,2.189-4.145,1.991-6.716C460.068,229.007,459.021,226.961,457.122,225.438z" />
    </svg>
  ),
  instagram: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path d="m301 256c0 24.851562-20.148438 45-45 45s-45-20.148438-45-45 20.148438-45 45-45 45 20.148438 45 45zm0 0" />
      <path d="m332 120h-152c-33.085938 0-60 26.914062-60 60v152c0 33.085938 26.914062 60 60 60h152c33.085938 0 60-26.914062 60-60v-152c0-33.085938-26.914062-60-60-60zm-76 211c-41.355469 0-75-33.644531-75-75s33.644531-75 75-75 75 33.644531 75 75-33.644531 75-75 75zm86-146c-8.285156 0-15-6.714844-15-15s6.714844-15 15-15 15 6.714844 15 15-6.714844 15-15 15zm0 0" />
      <path d="m377 0h-242c-74.4375 0-135 60.5625-135 135v242c0 74.4375 60.5625 135 135 135h242c74.4375 0 135-60.5625 135-135v-242c0-74.4375-60.5625-135-135-135zm45 332c0 49.625-40.375 90-90 90h-152c-49.625 0-90-40.375-90-90v-152c0-49.625 40.375-90 90-90h152c49.625 0 90 40.375 90 90zm0 0" />
    </svg>
  ),

  facebook: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path d="m437 0h-362c-41.351562 0-75 33.648438-75 75v362c0 41.351562 33.648438 75 75 75h151v-181h-60v-90h60v-61c0-49.628906 40.371094-90 90-90h91v90h-91v61h91l-15 90h-76v181h121c41.351562 0 75-33.648438 75-75v-362c0-41.351562-33.648438-75-75-75zm0 0" />
    </svg>
  ),

  linkedin: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
      <path d="m437 0h-362c-41.351562 0-75 33.648438-75 75v362c0 41.351562 33.648438 75 75 75h362c41.351562 0 75-33.648438 75-75v-362c0-41.351562-33.648438-75-75-75zm-256 406h-60v-210h60zm0-240h-60v-60h60zm210 240h-60v-120c0-16.539062-13.460938-30-30-30s-30 13.460938-30 30v120h-60v-210h60v11.308594c15.71875-4.886719 25.929688-11.308594 45-11.308594 40.691406.042969 75 36.546875 75 79.6875zm0 0" />
    </svg>
  ),

  youtube: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/1999/xlink"
      viewBox="0 0 504 504"
      style="enable-background:new 0 0 504 504;"
    >
      <polygon
        xmlns="http://www.w3.org/2000/svg"
        points="219.6,202.4 219.6,294.4 304.4,248.8   "
      />
      <path d="M377.6,0H126C56.8,0,0,56.8,0,126.4V378c0,69.2,56.8,126,126,126h251.6c69.6,0,126.4-56.8,126.4-126.4V126.4    C504,56.8,447.2,0,377.6,0z M408,264.4c0,26.4-2.4,53.2-2.4,53.2s-2.8,22.4-12,32.4c-12,13.2-25.2,13.2-31.2,14    c-44,3.2-110,3.6-110,3.6s-82-1.2-107.2-3.6c-6.8-1.2-22.8-0.8-34.8-14c-9.6-10-12-32.4-12-32.4S96,290.8,96,264.4v-24.8    c0-26.4,2.4-53.2,2.4-53.2s2.8-22.4,12-32.4c12-13.2,25.2-13.6,31.2-14.4C186,136.4,252,136,252,136s66,0.4,110,3.6    c6,0.8,19.6,1.2,31.6,14c9.6,10,12,32.8,12,32.8s2.4,26.8,2.4,53.2V264.4z" />
    </svg>
  ),

  twitter: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/1999/xlink"
      viewBox="0 0 504.4 504.4"
      style="enable-background:new 0 0 504.4 504.4;"
    >
      <path d="M377.6,0.2H126.4C56.8,0.2,0,57,0,126.6v251.6c0,69.2,56.8,126,126.4,126H378c69.6,0,126.4-56.8,126.4-126.4V126.6    C504,57,447.2,0.2,377.6,0.2z M377.2,189c0,2.8,0,5.6,0,8.4c0,84-64.8,180.8-183.6,180.8c-36.4,0-70.4-10.4-98.8-28.4    c5.2,0.4,10,0.8,15.2,0.8c30.4,0,58-10,80-27.2c-28.4-0.4-52-18.8-60.4-44c4,0.8,8,1.2,12,1.2c6,0,12-0.8,17.2-2.4    c-28.8-6-50.8-31.6-50.8-62.4V215c8,4.8,18.4,7.6,28.8,8c-17.2-11.2-28.8-30.8-28.8-52.8c0-11.6,3.2-22.4,8.8-32    c32,38.4,79.2,63.6,132.8,66.4c-1.2-4.8-1.6-9.6-1.6-14.4c0-35.2,28.8-63.6,64.4-63.6c18.4,0,35.2,7.6,47.2,20    c14.8-2.8,28.4-8,40.8-15.6c-4.8,14.8-15.2,27.2-28.4,35.2c13.2-1.6,25.6-4.8,37.2-10C400.4,169,389.6,180.2,377.2,189z" />
    </svg>
  ),

  flickr: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/1999/xlink"
      viewBox="0 0 504.4 504.4"
      style="enable-background:new 0 0 504.4 504.4;"
    >
      <path d="M377.6,0.2H126.4C56.8,0.2,0,57,0,126.6v251.6c0,69.2,56.8,126,126.4,126H378c69.6,0,126.4-56.8,126.4-126.4V126.6    C504,57,447.2,0.2,377.6,0.2z M158.8,325.4c-41.2,0-74.4-32.8-74.4-73.2s33.2-73.2,74.4-73.2c41.2,0,74.4,32.8,74.4,73.2    C233.2,292.6,199.6,325.4,158.8,325.4z M345.2,325.4c-41.2,0-74.4-32.8-74.4-73.2S304,179,345.2,179c41.2,0,74.4,32.8,74.4,73.2    C419.6,292.6,386.4,325.4,345.2,325.4z" />
    </svg>
  ),

  folder: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -8 394 394">
      <path d="m292.476562 48.902344h-79.675781c-1.015625-.003906-1.984375-.429688-2.667969-1.179688l-28.914062-31.628906c-9.378906-10.242188-22.621094-16.078125-36.507812-16.09375h-95.253907c-27.300781.03125-49.425781 22.15625-49.457031 49.457031v278.214844c.03125 27.300781 22.15625 49.425781 49.457031 49.457031h295.085938c27.300781-.03125 49.425781-22.15625 49.457031-49.457031v-178.214844c-.03125-27.300781-22.15625-49.425781-49.457031-49.457031h-2.609375v-1.640625c-.03125-27.300781-22.15625-49.425781-49.457032-49.457031zm-238.550781 314.226562h-4.46875c-19.574219-.023437-35.433593-15.886718-35.457031-35.457031v-278.214844c.023438-19.574219 15.882812-35.433593 35.457031-35.457031h95.253907c9.953124.011719 19.449218 4.195312 26.171874 11.535156l28.910157 31.636719c3.339843 3.644531 8.054687 5.722656 13 5.730469h79.679687c19.574219.023437 35.433594 15.882812 35.457032 35.457031v1.640625h-189.085938c-27.300781.03125-49.425781 22.15625-49.457031 49.460938v178.210937c-.023438 19.570313-15.886719 35.433594-35.460938 35.457031zm290.617188-249.128906c19.574219.023438 35.433593 15.882812 35.457031 35.457031v178.214844c-.023438 19.570313-15.882812 35.433594-35.457031 35.457031h-256.167969c9.601562-9.296875 15.015625-22.09375 15.011719-35.457031v-178.214844c.019531-19.574219 15.882812-35.433593 35.457031-35.457031zm0 0" />
      <path d="m190.53125 337.457031h102.324219c14.007812-.015625 25.359375-11.371093 25.375-25.378906v-115.839844c0-1.855469-.738281-3.640625-2.054688-4.953125l-49.566406-49.464844c-.011719-.011718-.027344-.019531-.039063-.03125-1.3125-1.351562-3.121093-2.117187-5.007812-2.117187-.160156 0-.3125.015625-.464844.023437-.15625-.007812-.3125-.023437-.46875-.023437h-70.097656c-14.011719.015625-25.363281 11.371094-25.378906 25.378906v147.027344c.015625 14.007813 11.367187 25.363281 25.378906 25.378906zm78.03125-173.910156 25.847656 25.800781h-14.472656c-6.277344-.007812-11.367188-5.097656-11.375-11.378906zm-89.410156 1.5c.007812-6.28125 5.097656-11.371094 11.378906-11.375h64.03125v24.296875c.015625 14.011719 11.367188 25.363281 25.375 25.378906h24.292969v108.730469c-.003907 6.28125-5.09375 11.371094-11.375 11.378906h-102.324219c-6.28125-.007812-11.371094-5.097656-11.378906-11.378906zm0 0" />
      <path d="m196.988281 233.148438h49.671875c3.867188 0 7-3.136719 7-7 0-3.867188-3.132812-7-7-7h-49.671875c-3.867187 0-7 3.132812-7 7 0 3.863281 3.132813 7 7 7zm0 0" />
      <path d="m196.988281 267.917969h89.410157c3.867187 0 7-3.136719 7-7 0-3.867188-3.132813-7-7-7h-89.410157c-3.867187 0-7 3.132812-7 7 0 3.863281 3.132813 7 7 7zm0 0" />
      <path d="m196.988281 302.6875h89.410157c3.867187 0 7-3.132812 7-7s-3.132813-7-7-7h-89.410157c-3.867187 0-7 3.132812-7 7s3.132813 7 7 7zm0 0" />
    </svg>
  ),

  doubleAngleRight: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/1999/xlink"
      viewBox="0 0 284.936 284.936"
      style="enable-background:new 0 0 284.936 284.936;"
    >
      <path d="M277.515,135.9L144.464,2.857C142.565,0.955,140.375,0,137.9,0c-2.472,0-4.659,0.955-6.562,2.857l-14.277,14.275    c-1.903,1.903-2.853,4.089-2.853,6.567c0,2.478,0.95,4.664,2.853,6.567l112.207,112.204L117.062,254.677    c-1.903,1.903-2.853,4.093-2.853,6.564c0,2.477,0.95,4.667,2.853,6.57l14.277,14.271c1.902,1.905,4.089,2.854,6.562,2.854    c2.478,0,4.665-0.951,6.563-2.854l133.051-133.044c1.902-1.902,2.851-4.093,2.851-6.567S279.417,137.807,277.515,135.9z" />
      <path d="M170.732,142.471c0-2.474-0.947-4.665-2.857-6.571L34.833,2.857C32.931,0.955,30.741,0,28.267,0s-4.665,0.955-6.567,2.857    L7.426,17.133C5.52,19.036,4.57,21.222,4.57,23.7c0,2.478,0.95,4.664,2.856,6.567L119.63,142.471L7.426,254.677    c-1.906,1.903-2.856,4.093-2.856,6.564c0,2.477,0.95,4.667,2.856,6.57l14.273,14.271c1.903,1.905,4.093,2.854,6.567,2.854    s4.664-0.951,6.567-2.854l133.042-133.044C169.785,147.136,170.732,144.945,170.732,142.471z" />
    </svg>
  ),

  angleRight: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/1999/xlink"
      viewBox="0 0 444.819 444.819"
      style="enable-background:new 0 0 444.819 444.819;"
    >
      <path d="M352.025,196.712L165.884,10.848C159.029,3.615,150.469,0,140.187,0c-10.282,0-18.842,3.619-25.697,10.848L92.792,32.264   c-7.044,7.043-10.566,15.604-10.566,25.692c0,9.897,3.521,18.56,10.566,25.981l138.753,138.473L92.786,361.168   c-7.042,7.043-10.564,15.604-10.564,25.693c0,9.896,3.521,18.562,10.564,25.98l21.7,21.413   c7.043,7.043,15.612,10.564,25.697,10.564c10.089,0,18.656-3.521,25.697-10.564l186.145-185.864   c7.046-7.423,10.571-16.084,10.571-25.981C362.597,212.321,359.071,203.755,352.025,196.712z" />
    </svg>
  ),

  thinAngleRight: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/1999/xlink"
      viewBox="0 0 792.049 792.049"
      style="enable-background:new 0 0 792.049 792.049;"
    >
      <path d="M622.955,342.127L268.424,20.521c-27.36-27.36-71.677-27.36-99.037,0c-27.36,27.36-27.36,71.676,0,99.037     l304.749,276.468L169.387,672.492c-27.36,27.359-27.36,71.676,0,99.036s71.677,27.36,99.037,0l354.531-321.606     c14.783-14.783,21.302-34.538,20.084-53.897C644.225,376.665,637.738,356.911,622.955,342.127z" />
    </svg>
  ),

  prevPage: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
    </svg>
  ),

  nextPage: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M0 0h24v24H0z" fill="none" />
      <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z" />
    </svg>
  ),

  firstPage: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
      <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z" />
      <path d="M24 24H0V0h24v24z" fill="none" />
    </svg>
  ),

  lastPage: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      fill="black"
      width="18px"
      height="18px"
    >
      <path d="M0 0h24v24H0V0z" fill="none" />
      <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z" />
    </svg>
  ),
  eye:(
    <svg 
      version="1.0" 
      xmlns="http://www.w3.org/2000/svg"
      width="512.000000pt" 
      height="512.000000pt"
      >
    <g 
    transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
    stroke="none">
      <path d="M2415 4204 c-699 -56 -1461 -487 -2109 -1193 -276 -300 -301 -338 -301 -451 0 -113 25 -151 301 -451 602 -655 1290 -1068 1959 -1175 150 -24 440 -24 590 0 669 107 1357 520 1959 1175 276 300 301 338 301 451 0 113 -25 151 -301 451 -593 645 -1283 1064 -1929 1169 -116 19 -369 32 -470 24z m347 -469 c238 -42 449 -149 624 -317 414 -398 485 -1039 167 -1517 -421 -633 -1325 -715 -1851 -167 -218 227 -332 511 -332 826 0 581 410 1069 985 1175 98 18 303 18 407 0z"/>
      <path d="M2385 3364 c-316 -69 -567 -325 -631 -643 -20 -101 -15 -281 11 -376 24 -88 98 -231 158 -305 102 -125 270 -234 427 -277 91 -25 329 -25 420 0 93 26 234 99 310 160 125 102 234 270 277 427 25 91 25 329 0 420 -43 157 -152 325 -277 427 -74 60 -217 134 -305 158 -87 24 -301 29 -390 9z m113 -421 l-3 -137 -30 -6 c-76 -16 -137 -76 -151 -148 l-6 -32 -134 0 c-154 0 -147 -6 -119 103 23 87 61 155 124 218 76 76 166 119 276 132 17 2 34 5 38 6 4 0 6 -61 5 -136z"/>
    </g>
  </svg>
  ),
  email: (
    <svg 
      xmlns="http://www.w3.org/2000/svg"
 
      viewBox="0 0 512.000000 512.000000"
    >
     
    <g 
      transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
      stroke="none"
    >
      <path d="M413 4465 c-29 -8 -69 -21 -89 -30 -57 -23 -156 -99 -197 -149 -43 -51 -97 -150 -97 -175 0 -10 409 -288 1154 -784 1280 -852 1204 -808 1376 -808 172 0 96 -44 1376 808 745 496 1154 774 1154 784 0 25 -54 124 -97 175 -49 61 -150 131 -232 163 l-66 26 -2115 2 c-1792 2 -2123 0 -2167 -12z"/>
      <path d="M0 2438 c0 -1446 -2 -1377 55 -1494 60 -123 182 -231 313 -276 l67 -23 2130 0 2130 0 69 28 c177 71 309 222 346 397 8 40 10 407 8 1378 l-3 1322 -1090 -727 c-600 -399 -1113 -737 -1141 -750 -181 -83 -418 -87 -619 -12 -39 15 -427 267 -1150 749 -599 399 -1096 730 -1102 734 -10 6 -13 -262 -13 -1326z"/>
    </g>
    </svg>
  ),
  /* eye:(
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      xmlns:xlink="http://www.w3.org/1999/xlink"
      x="0px" y="0px"
      width="511.626px" 
      height="511.626px" 
      viewBox="0 0 511.626 511.626" 
      style="enable-background:new 0 0 511.626 511.626"
      xml:space="preserve">
      <path d="M505.918,236.117c-26.651-43.587-62.485-78.609-107.497-105.065c-45.015-26.457-92.549-39.687-142.608-39.687
        c-50.059,0-97.595,13.225-142.61,39.687C68.187,157.508,32.355,192.53,5.708,236.117C1.903,242.778,0,249.345,0,255.818
        c0,6.473,1.903,13.04,5.708,19.699c26.647,43.589,62.479,78.614,107.495,105.064c45.015,26.46,92.551,39.68,142.61,39.68
        c50.06,0,97.594-13.176,142.608-39.536c45.012-26.361,80.852-61.432,107.497-105.208c3.806-6.659,5.708-13.223,5.708-19.699
        C511.626,249.345,509.724,242.778,505.918,236.117z M194.568,158.03c17.034-17.034,37.447-25.554,61.242-25.554
        c3.805,0,7.043,1.336,9.709,3.999c2.662,2.664,4,5.901,4,9.707c0,3.809-1.338,7.044-3.994,9.704
        c-2.662,2.667-5.902,3.999-9.708,3.999c-16.368,0-30.362,5.808-41.971,17.416c-11.613,11.615-17.416,25.603-17.416,41.971
        c0,3.811-1.336,7.044-3.999,9.71c-2.667,2.668-5.901,3.999-9.707,3.999c-3.809,0-7.044-1.334-9.71-3.999
        c-2.667-2.666-3.999-5.903-3.999-9.71C169.015,195.482,177.535,175.065,194.568,158.03z M379.867,349.04
        c-38.164,23.12-79.514,34.687-124.054,34.687c-44.539,0-85.889-11.56-124.051-34.687s-69.901-54.2-95.215-93.222
        c28.931-44.921,65.19-78.518,108.777-100.783c-11.61,19.792-17.417,41.207-17.417,64.236c0,35.216,12.517,65.329,37.544,90.362
        s55.151,37.544,90.362,37.544c35.214,0,65.329-12.518,90.362-37.544s37.545-55.146,37.545-90.362
        c0-23.029-5.808-44.447-17.419-64.236c43.585,22.265,79.846,55.865,108.776,100.783C449.767,294.84,418.031,325.913,379.867,349.04
        z"/>
    </svg>

  ), */
  watch: (
    <svg
      fill="#ffffff"
      width="20px"
      height="20px"
      viewBox="0 0 1920 1920"
      xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M960 1489.82c-348.474 0-668.545-202.323-841.298-529.918C291.455 632.306 611.526 429.984 960 429.984s668.545 202.322 841.298 529.918C1628.545 1287.497 1308.474 1489.82 960 1489.82Zm948.342-553.552C1720.645 558.648 1357.332 324 960 324c-397.333 0-760.645 234.648-948.342 612.268L0 959.902l11.658 23.634c187.697 377.62 551.01 612.268 948.342 612.268 397.333 0 760.645-234.648 948.342-612.268L1920 959.902l-11.658-23.634ZM960 1171.869c-116.9 0-211.967-95.067-211.967-211.967 0-116.9 95.067-211.967 211.967-211.967 116.9 0 211.967 95.067 211.967 211.967 0 116.9-95.067 211.967-211.967 211.967m0-529.918c-175.297 0-317.951 142.654-317.951 317.951 0 175.297 142.654 317.95 317.951 317.95 175.297 0 317.951-142.653 317.951-317.95S1135.297 641.951 960 641.951" fill-rule="evenodd"></path>
      </g>
    </svg>
  ),
  download: (
  <svg
    width="20px"
    height="20px"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
      <g>
        <path d="M13.5 3H12H8C6.34315 3 5 4.34315 5 6V18C5 19.6569 6.34315 21 8 21H12M13.5 3L19 8.625M13.5 3V7.625C13.5 8.17728 13.9477 8.625 14.5 8.625H19M19 8.625V11.8125" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path> <path d="M17.5 15V21M17.5 21L15 18.5M17.5 21L20 18.5" stroke="#ffffff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
      </g>
  </svg>
  ),
  default: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns="http://www.w3.org/1999/xlink"
      viewBox="0 0 365.442 365.442"
      style="enable-background:new 0 0 365.442 365.442;"
    >
      <path d="M212.994,274.074h-68.522c-3.042,0-5.708,1.149-7.992,3.429c-2.286,2.286-3.427,4.948-3.427,7.994v68.525    c0,3.046,1.145,5.712,3.427,7.994c2.284,2.279,4.947,3.426,7.992,3.426h68.522c3.042,0,5.715-1.144,7.99-3.426    c2.29-2.282,3.433-4.948,3.433-7.994v-68.525c0-3.046-1.14-5.708-3.433-7.994C218.709,275.217,216.036,274.074,212.994,274.074z" />
      <path d="M302.935,68.951c-7.806-14.378-17.891-26.506-30.266-36.406c-12.367-9.896-26.271-17.799-41.685-23.697    C215.567,2.952,200.246,0,185.016,0C127.157,0,83,25.315,52.544,75.946c-1.521,2.473-2.046,5.137-1.571,7.993    c0.478,2.852,1.953,5.232,4.427,7.135l46.824,35.691c2.474,1.52,4.854,2.281,7.139,2.281c3.427,0,6.375-1.525,8.852-4.57    c13.702-17.128,23.887-28.072,30.548-32.833c8.186-5.518,18.461-8.276,30.833-8.276c11.61,0,21.838,3.046,30.692,9.132    c8.85,6.092,13.271,13.135,13.271,21.129c0,8.942-2.375,16.178-7.135,21.698c-4.757,5.518-12.754,10.845-23.986,15.986    c-14.842,6.661-28.457,16.988-40.823,30.978c-12.375,13.991-18.558,28.885-18.558,44.682v12.847c0,3.62,0.994,7.187,2.996,10.708    c2,3.524,4.425,5.283,7.282,5.283h68.521c3.046,0,5.708-1.472,7.994-4.432c2.279-2.942,3.426-6.036,3.426-9.267    c0-4.757,2.617-11.14,7.847-19.13c5.235-7.994,11.752-14.186,19.562-18.565c7.419-4.186,13.219-7.56,17.411-10.133    c4.196-2.566,9.664-6.715,16.423-12.421c6.756-5.712,11.991-11.375,15.698-16.988c3.713-5.614,7.046-12.896,9.996-21.844    c2.956-8.945,4.428-18.558,4.428-28.835C314.639,98.397,310.734,83.314,302.935,68.951z" />
    </svg>
  )
};
export default svgs;
